import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../templates/AppContextProvider';

type Namespace = Parameters<typeof useTranslation>[0];

/**
 * `useTranslation`ラッパー
 *
 * 言語設定が
 * @param ns
 * @returns
 */
export function useTranslationWithLang(ns: Namespace) {
  const { currentLang } = useContext(AppContext);
  const { t } = useTranslation(ns, { lng: currentLang });
  return { t };
}
